<template>
  <div class="tab-ctnr--common">
    <div class="table-area">
      <div class="t-title">
        海运费
      </div>
      <div class="t-content">
        <el-table
          class="table-comp"
          ref="table"
          :data="oceanTableData"
          v-loading="loading"
          stripe
          border
        >
          <el-table-column
            prop="costDetail"
            min-width="600"
            label="费用名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="currency"
            min-width="253"
            label="币种"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="price"
            min-width="260"
            label="单价"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              <template v-if="$emp(row.price)">
                -
              </template>
              <template v-else>
                <template v-if="!$emp(row.unit)">
                  {{ row.price }}/{{ row.unit }}
                </template>
                <template v-else>
                  {{ row.price }}
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="table-area">
      <div class="t-title">
        起运港费用
      </div>
      <div class="t-content">
        <el-table
          class="table-comp"
          ref="table"
          :data="startTableData"
          v-loading="loading"
          stripe
          border
        >
          <el-table-column
            prop="costDetail"
            min-width="600"
            label="费用名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="currency"
            min-width="253"
            label="币种"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="price"
            min-width="260"
            label="单价"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              <template v-if="$emp(row.price)">
                -
              </template>
              <template v-else>
                <template v-if="!$emp(row.unit)">
                  {{ row.price }}/{{ row.unit }}
                </template>
                <template v-else>
                  {{ row.price }}
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="table-area">
      <div class="t-title">
        目的港费用
      </div>
      <div class="t-content">
        <el-table
          class="table-comp"
          ref="table"
          :data="endTableData"
          v-loading="loading"
          stripe
          border
        >
          <el-table-column
            prop="costDetail"
            min-width="600"
            label="费用名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="currency"
            min-width="253"
            label="币种"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="price"
            min-width="260"
            label="单价"
            show-overflow-tooltip
          >
            <template v-slot="{ row }">
              <template v-if="$emp(row.price)">
                -
              </template>
              <template v-else>
                <template v-if="!$emp(row.unit)">
                  {{ row.price }}/{{ row.unit }}
                </template>
                <template v-else>
                  {{ row.price }}
                </template>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    oceanTableData() {
      if (!this.detail.costDetailParseResult) {
        return [];
      }
      return [
        ...this.detail.costDetailParseResult.oceanList,
        ...this.detail.costDetailParseResult.surchargeList
      ];
    },
    startTableData() {
      if (!this.detail.costDetailParseResult) {
        return [];
      }

      return [...this.detail.costDetailParseResult.exportSurchargeList];
    },
    endTableData() {
      if (!this.detail.costDetailParseResult) {
        return [];
      }

      return [...this.detail.costDetailParseResult.importSurchargeList];
    }
  },
  components: {},
  data() {
    return {
      loading: false
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
@import "./common.scss";
</style>
